module.exports = __webpack_public_path__ + "img/monitor.53441bd7.svg";